<template>
    <div ref="chart"></div>
</template>
<script>
import Highcharts from "highcharts";

export default {
    name: "chart-profit",
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            chart: null
        };
    },
    methods: {
        reload() {
            if (this.chart) this.chart.destroy();

            let series = [];
            if (this.data.currencies.length == 1) {
                let cur = this.data.currencies[0];
                series.push({
                    name: `${cur.currency} - In`,
                    data: cur.in
                });
                series.push({
                    name: `${cur.currency} - Out`,
                    data: cur.out
                });
                series.push({
                    name: `${cur.currency} - Profit`,
                    data: cur.profit
                });
            } else {
                this.data.currencies.forEach(c => {
                    series.push({
                        name: `${c.currency} - Profit`,
                        data: c.profit
                    })
                });
            }

            this.chart = Highcharts.chart(this.$refs.chart, {
                chart: {
                    type: "spline"
                },
                title: {
                    text: ""
                },
                xAxis: {
                    type: "datetime"
                },
                yAxis: {
                    plotLines: [
                        {
                            value: 0,
                            color: "#888",
                            width: 1,
                            zIndex: 4
                        }
                    ]
                },
                legend: {
                    layout: "vertical",
                    align: "right",
                    verticalAlign: "middle"
                },
                tooltip: {
                    crosshairs: true,
                    shared: true
                },
                plotOptions: {
                    line: {
                        dataLabels: {
                            enabled: true
                        },
                        pointInterval: 24 * 60 * 60 * 1000 // one day
                    },
                    series: {
                        marker: {
                            symbol: "circle",
                            radius: 3
                        }
                    }
                },
                series: series
            });
        }
    }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/components/stats/chart-profit.vue